<template>
  <div id="vessel-monitoring-engine-list">
    <div
      class="vx-card p-6 list-container"
      id="vessel-monitoring-engine-list-card"
    >
      <div class="flex flex-wrap items-center mb-base">
        <div class="table-area-wrapper flex-grow">
          <div class="table-area">
            <!-- カラム: 船名・データ取得元・更新時刻 -->
            <div class="header row aisea-text-14-700-dark-gray w-full">
              <div
                class="cell"
                v-for="(column, index) in columns"
                :key="index"
                :class="{
                  [`cell-${column.key}`]: true,
                  'ml-auto': column.key == 'lastUpdatedAt',
                }"
                :style="'width:' + column.width"
              >
                {{ column.label }}
              </div>
            </div>

            <!-- 行 -->
            <div
              class="
                data
                row
                aisea-text-14-400-black
                clickable-cell-container
                w-full
              "
              v-for="(
                vesselMonitoringEngine, index
              ) in vesselMonitoringEngineList"
              :key="index"
              @click="
                goToDataReport(vesselMonitoringEngine.enterprise_vessel_id)
              "
            >
              <div
                class="cell"
                v-for="(column, index) in columns"
                :key="index"
                :class="{
                  [`cell-${column.key}`]: true,
                  'ml-auto': column.key == 'lastUpdatedAt',
                }"
                :style="'width:' + column.width"
              >
                <div v-if="column.key == 'name'" class="truncate">
                  <div
                    class="truncate"
                    :class="{
                      'col-data-name-mobile': ['iPhone', 'iPad'].includes(
                        deviceInfo.deviceType,
                      ),
                    }"
                  >
                    {{
                      vesselMonitoringEngine.name_ja ||
                      vesselMonitoringEngine.name
                    }}
                  </div>
                </div>

                <div v-if="column.key == 'origins'" class="truncate">
                  <div class="aisea-text-14-400-black truncate">
                    {{ vesselMonitoringEngine.channelOriginsDisp }}
                  </div>
                </div>
                <div v-if="column.key == 'lastUpdatedAt'">
                  <!-- cell -->
                  <div
                    class="
                      last-updated-at-wrapper
                      flex flex-no-wrap flex-shrink-0
                      items-center
                      gap-1
                      mr-auto
                    "
                  >
                    <div
                      v-show="vesselMonitoringEngine.lastUpdatedAtDisp"
                      class="
                        last-updated-at
                        flex flex-no-wrap flex-shrink-0
                        items-center
                        gap-1
                      "
                    >
                      <span class="aisea-text-14-400-black flex-shrink-0">
                        {{ vesselMonitoringEngine.lastUpdatedAtDisp }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { createNamespacedHelpers } from "vuex";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const EnterpriseVesselApi = AiseaApiFactory.get("enterpriseVessel");
const { mapState, mapActions } = createNamespacedHelpers("enterpriseVesselMonitoringEngine");
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
const epVesselDisplayChannelApi = AiseaApiFactory.get(
  "enterpriseVesselDisplayChannel",
);
const { mapActions: mapActionsEcoship } = createNamespacedHelpers("ecoShip");
import { db } from "@/firebase/firebaseConfig.js";

export default {
  name: "VesselMonitaringEngineList",
  components: {},
  mixins: [DeviceInfoMixin, ColorMixin],
  data() {
    return {
      vesselMonitoringEngineList: [],
      columns: [],
      baseColumns: [
        {
          key: "name",
          label: "船名",
          width: "180px",
          unit: null,
        },
        {
          key: "origins",
          label: "取得データ元機器名",
          width: "400px",
          unit: null,
        },
        {
          key: "lastUpdatedAt",
          label: "更新日時",
          width: "180px",
          unit: null,
        },
      ],
      deviceInfo: null,
      unsubscribes: [],
    }
  },
  computed: {
    ...mapState({
      engineInfo: state => state.engineInfo,
    }),
  },
  watch: {
    onChangeWindowSize() {
      this.onResize();
    },
  },
  methods: {
    ...mapActions(["fetchVoyageHistories"]),
    ...mapActionsEcoship(["getVersion"]),

    /**
     *  データレポートページへ遷移.
     */
    async goToDataReport(enterpriseVesselId) {
      this.$router.push({
        name: "addon-eco-ship-vessel-monitoring-engine",
        params: {
          id: enterpriseVesselId,
          vesselMonitoringEngineList: this.vesselMonitoringEngineList,
        },
      });
    },


    /**
     *  iPhone,iPadでのレフトメニュー表示制御.
     */
    onResize() {
      if ( ['iPhone', 'iPad'].includes(this.deviceInfo.deviceType) ) {
        // iPhone, iPad はメニューを表示しない。
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false);
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu');
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
        const verticalNavMenuWidth = this.$store.state.reduceButton
          ? "reduced"
          : "default";
        this.$store.dispatch("updateVerticalNavMenuWidth", verticalNavMenuWidth);
      }

      const routerHeaderElements = document.getElementsByClassName("router-header");
      if ( routerHeaderElements ) {
        const cardElement = document.getElementById('vessel-monitoring-engine-list-card');
         const routerHeaderRect = routerHeaderElements[0].getBoundingClientRect(); 
        const bottomBuffer =  ( ['iPhone', 'iPad'].includes(this.deviceInfo.deviceType) ? 60 : 80 )+ 'px';
        cardElement.style.setProperty('min-height', `calc( 100vh - ${routerHeaderRect.height}px - ${bottomBuffer} )`) ;
      }
    },

    /**
     *  機関データ一覧の生成.
     */
    async setVesselMonitoringEngineList() {
      // 自社有効船舶をリストで取得
      let payload = {
        is_disabled: false,
        is_deleted: false,
        page: 0,
        limit: 9999,
      };
      let res = await EnterpriseVesselApi.search(payload);  
      let vesselList = res.data.vessels;

      // searchVoyageHistoriesを使って、各船舶の航海履歴を取得
      let promiseAll = [];
      vesselList
      .filter( vessel => vessel.vessel_origins && vessel.vessel_origins.length > 0 )
      .forEach( vessel => {
        promiseAll.push(( async () => {
          const vesselMonitoringEngine = vessel;
          vesselMonitoringEngine.selectedHistoryYear = null;

          // 現在年のリアルタイム表示へのルートを用意しておく。
          const currentVoyage = {
            id: "live",
            displayFromTo: "リアルタイム",
          };

          // 初期は常にリアルタイム表示
          vesselMonitoringEngine.histories = [currentVoyage];
          vesselMonitoringEngine.selectedHistoryId = "live";

          // 期間データ取得元を取得
          try {
            const res = await epVesselDisplayChannelApi.getChannelOrigins(
              vesselMonitoringEngine.enterprise_vessel_id,
            );
            vesselMonitoringEngine.channelOrigins = res.data.channel_origins
              .slice()
              .sort((a, b) => a.sort_order - b.sort_order);
          } catch {
            vesselMonitoringEngine.channelOrigins = [];
          } finally {
            vesselMonitoringEngine.channelOriginsDisp =
              vesselMonitoringEngine.channelOrigins
                .map((origin) => origin.name_loc || origin.name)
                .join(", ");
          }

          return vesselMonitoringEngine;
        })(),
        );
      });
      let resultList = await Promise.all(promiseAll);

      this.vesselMonitoringEngineList = resultList.filter(
        (vesselMonitoringEngine) =>
          vesselMonitoringEngine.channelOrigins &&
          vesselMonitoringEngine.channelOrigins.length > 0,
      );
      this.vesselMonitoringEngineList.forEach((vesselMonitoringEngine) => {
        vesselMonitoringEngine.channelOrigins.forEach(async (co) => {
          try {
            const payloadForVersion = {
              vessel_id: vesselMonitoringEngine.id,
              params: {
                kind: co.kind,
                origin: co.origin_number,
              },
            };
            const res = await this.getVersion(payloadForVersion);
            if (res.version_name) {
              const versionName = res.version_name;
              const docRef = db
                .collection("vessel_channel_data")
                .doc("v_" + vesselMonitoringEngine.id)
                .collection(co.kind)
                .doc(versionName)
                .collection("data")
                .doc("last_updated_at");
              const subscribe = await docRef.onSnapshot((snapshot) => {
                const lastTimestampDate = snapshot.data().timestamp.toDate();
                if (
                  !vesselMonitoringEngine.lastTimestampDate ||
                  vesselMonitoringEngine.lastTimestampDate < lastTimestampDate
                ) {
                  vesselMonitoringEngine.lastTimestampDate = lastTimestampDate;
                  // 2021/01/03/12:00
                  vesselMonitoringEngine.lastUpdatedAtDisp =
                    moment(lastTimestampDate).format("YYYY/MM/DD HH:mm");
                  // リストの描画を更新するために、再代入する
                  this.vesselMonitoringEngineList =
                    this.vesselMonitoringEngineList.map((vme) => {
                      if (vme.id === vesselMonitoringEngine.id)
                        return vesselMonitoringEngine;
                      return vme;
                    });
                }
              });
              this.unsubscribes = [...this.unsubscribes, subscribe];
            }
          } catch {
            console.log("error");
          }
        });
      });
    },

  },
  created() {
    this.deviceInfo = this.getDeviceInfo();
    this.columns = this.baseColumns;
  },
  mounted() {

    let routerViewElement = document.getElementsByClassName("router-view")
    routerViewElement[0].style.padding = "2.2rem"

    this.onResize();
    this.setVesselMonitoringEngineList();
  },
  beforeDestroy() {
    this.unsubscribes.forEach((unsubscribe) => {
      unsubscribe();
    });
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
#vessel-monitoring-engine-list {

  .list-container {
    overflow-x: scroll;
    max-width: 1360px;
    
  }
  .table-area-wrapper {
    overflow-x: scroll;
    position: relative;
    height: 560px;
    .table-area {
      min-width: fit-content;
      width: 100%;
    }
  }
  .header {
    font-weight: bold;
  }
  .row {
    min-height: 49px;
    height: fit-content;
    display: flex;
    border-bottom: solid 1px $aisea-light-gray;
    cursor: pointer;
  }
  .clickable-cell-container {
    display: flex;
    transition: 0.3s;
    cursor: pointer;
    &:hover {
      background: $aisea-white;
    }
  }
  .cell {
    display: flex;
    margin-right: 20px;
    padding: 5px 10px;
    align-items: center;
    &.cell-vesselName {
      overflow-wrap: anywhere;
    }
  }

  .year-select-box {
    min-width: 7rem;
    width:     7rem;
    margin: 0.4rem 0.2rem 0.4rem 0;
    .vs__dropdown-toggle {
      height: 2.8rem;
    }
    .vs__selected-options {
      padding-top: 0.2rem;
      width: calc(7rem - 26.5px);
    }
  }
  .period-select-box {
    min-width: 22rem;
    width:     22rem;
    margin: 0.4rem 0;
    .vs__dropdown-toggle {
      height: 2.8rem;
    }
  }
  .action-button {
    padding:0.5rem 1.4rem;
  }

  .cell-name {
    margin-right: 0;
  }
  .cell-actionButton {
    margin-right: 0;
  }

  .col-data-name-mobile {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
